export function cashAccessSaved(locale, name, accounts) {
    return locale === 'az' ? `${name}: giriş icazələri saxlanıldı${accounts === undefined ? '.' : ` · ${accounts} hesab.`}` :
        locale === 'ru' ? `${name}: права сохранены${accounts === undefined ? '.' : ` · счетов: ${accounts}.`}` :
            `${name}: permissions saved${accounts === undefined ? '.' : ` · accounts: ${accounts}.`}`;
}
export function cashAccessMissingUser(locale) {
    return locale === 'az' ? 'Bu əməkdaş üçün giriş təyin etmək mümkün deyil. Siyahıdan aktiv əməkdaş seçin.' :
        locale === 'ru' ? 'Этот сотрудник недоступен для выдачи прав. Выберите активного сотрудника из списка.' :
            'This employee is unavailable for permission assignment. Choose an active employee from the list.';
}
export function cashAccountAccessHelp(locale) {
    return locale === 'az' ? 'Rəhbərinizdən «İstifadəçilər və giriş» bölməsində adınızı seçib Kassa girişini təyin etməsini xahiş edin.' :
        locale === 'ru' ? 'Попросите руководителя настроить для вас Кассу: «Пользователи и доступы» → ваше имя.' :
            'Ask your manager to open Users and access, select your name and set up Cash access.';
}
